import { Pipe, PipeTransform } from '@angular/core';
import { parse, format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

@Pipe({
    name: 'dateFormat',
})
export class DateFormatPipe implements PipeTransform {
    transform(value: string, inputFormat: string = 'dd/MM/yyyy', outputFormat: string = 'yyyy-MM-dd'): string {
        if (!value) return '';

        // Parse the date using the provided input format
        const parsedDate = parse(value, inputFormat, new Date());

        // Format the date to the desired output format
        return format(parsedDate, outputFormat, { locale: ptBR });
    }
}
